import React,{useState} from 'react'
import {Link} from 'react-router-dom'
import useAsync from '../../hooks/useAsync';
import PlanServices from '../../services/PlanServices.js';
import UserStatus from './TogelButton/UserStatus';
import Modal from 'react-modal';
import DeleteButton from './Button/DeleteButton';
import PlanUpdate from './Update Model/PlanUpdate';

function Subscription() {
  
  const { data, error, isLoading, run } = useAsync(PlanServices.subscriptionList);
  console.log(data)

  const [activeIndex, setActiveIndex] = useState(null);
const [isEditModalOpen, setIsEditModalOpen] = useState(false);
const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
const [selectedEdit, setSelectedEdit] = useState(null);
const [searchTerm, setSearchTerm] = useState('');
const [filteredData, setFilteredData] = useState(data?.data || []);

  const handleDelete = (help) => {
      setSelectedEdit(help);
      setIsDeleteModalOpen(true);
      toggleActionMenu(null);
    };

    
    const closeDeleteModal = () => {
      setIsDeleteModalOpen(false);
      setSelectedEdit(null);
    };

    const handleEditDetails = (help) => {
      setSelectedEdit(help);
      setIsEditModalOpen(true);
      toggleActionMenu(null);
    };

    const closeEditModal = () => {
      setIsEditModalOpen(false);
      setSelectedEdit(null);
    };
  
    function formatDateTime(isoString) {
      const date = new Date(isoString);
      const formattedDate = date.toLocaleDateString();
      const formattedTime = date.toLocaleTimeString();
      return formattedDate;
    }


    const toggleActionMenu = (index) => {
      setActiveIndex(index === activeIndex ? null : index); // Toggle the active index
    };
  return (
    
    <div className="right_col" role="main">
    <div className="title-box">
      <h2>Subscription List <span className="badge bg-orange">02</span></h2>
      <div className="container-box-top-header-right d-flex">
        <Link to="/admin/add-subscription" className="single-product-btn me-2"><i className="fa fa-plus me-2" />Add Subscription</Link>
        <button className="excel-btn"><img src="img/excel.svg" />Download</button>
      </div>
    </div>
    <div className="container-box px-0">
      <div className="container-box-top-header px-4">
        <div className="container-box-top-header-left-2">
          <input type="search" name="search" placeholder="Search" />
          <button className="search-btn">Search</button>
        </div>
      </div>
      <div className="container-box-inner">
        <table id="example" className="table table-striped" style={{width: '100%'}}>
          <thead>
            <tr>
              <th>subscription <br />Type</th>
              <th>User Name</th>
              <th>Mobile No.</th>
              <th>Registration date</th>
              <th>Expire date</th>
              <th>Amounts</th>
              <th>Payment<br />Method</th>
              <th>ACTION</th>
            </tr>
          </thead>
          <tbody>
          {data?.data?.map((plan, index) => (
            <tr>
              <td><span className="usertype">Monthly</span></td>
              <td>{plan.user.name}</td>
              <td>{plan?.user?.mobileNo}</td>
              <td>{formatDateTime(plan?.startDate)}</td>
              <td>{formatDateTime(plan?.endDate)}</td>
              <td>₹ {plan?.price}</td>
              <td>Online</td>
              <td>
              <div className="action_toggle_outer">
                        <button
                          className="action_toggle"
                          onClick={() => toggleActionMenu(index)}
                        >
                          <i className="fa fa-ellipsis-v" />
                        </button>
                        {activeIndex === index && (
                          <div className="action_toggle_content product-edit show d-block">
                            <ul className="list-unstyled">
                              <li><button className="close_toggle" onClick={() => toggleActionMenu(null)}><i className="fa fa-close" /></button></li>
                              <li><button className="edit" onClick={() => handleEditDetails(plan)}>Edit</button></li>
                              <li><button className="reject" onClick={() => handleDelete(plan)}>Delete</button></li>
                            </ul>
                          </div>
                        )}
                      </div>
                
              </td>
            </tr>
           ))}
          </tbody>
        </table>
      </div>
    </div>
    <Modal
          isOpen={isDeleteModalOpen}
          onRequestClose={closeDeleteModal}
          contentLabel="Delete Confirmation"
          className="modal-content"
          overlayClassName="modal-overlay"
        >
          <DeleteButton data={selectedEdit} page="subscription" closeModal={closeDeleteModal} onSuccess={run} />
        </Modal>
  </div>
  )
}

export default Subscription